<template>
  <div id="cancelschedule">
    <div class="container admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">CANCEL SCHEDULE</h3>
        </div>
        <div class="col-lg-7">
          <div class="attendance-search">
            <el-select v-model="cancelScheduleType" placeholder="Select Type" class="pro-edt-select" @change="Load()">
              <el-option v-for="item in cancelScheduleTypeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="pb-5">
        <div
          class="empty-list_image"
          v-if="
            pendingListInt.length < 1 &&
            pendingListWGInt.length < 1 &&
            classScheduleInt.length < 1 &&
            busScheduleInt.length < 1 &&
            parentWithdrawlFormInt.length < 1
          "
        >
          <img src="../assets/attendance.jpg" />
        </div>
        <div v-if="pendingListInt.length > 0">
          <el-row>
            <el-col :span="6">
              <el-input v-model="pendingListFilters[0].value" placeholder="search student name"></el-input>
            </el-col>
          </el-row>
          <data-tables :data="pendingListInt" :action-col="pendingListActionCol" :filters="pendingListFilters">
            <el-table-column
              v-for="pendingListInfo in pendingList"
              :prop="pendingListInfo.prop"
              :label="pendingListInfo.label"
              :key="pendingListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
        <div v-if="pendingListWGInt.length > 0">
          <el-row>
            <el-col :span="12">
              <el-input v-model="pendingListWGFilters[0].value" placeholder="search student name / class name"></el-input>
            </el-col>
            <el-col :span="12">
              <button
                v-on:click="RemoveWithdrawGraduatePendingSchedule()"
                class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch float-right"
              >
                Delete
              </button>
            </el-col>
          </el-row>
          <data-tables :data="pendingListWGInt" :filters="pendingListWGFilters" @selection-change="changeSelection">
            <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
            <el-table-column
              v-for="pendingListWGInfo in pendingListWG"
              :prop="pendingListWGInfo.prop"
              :label="pendingListWGInfo.label"
              :key="pendingListWGInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
        <div v-if="classScheduleInt.length > 0">
          <el-row>
            <el-col :span="6">
              <el-input v-model="classScheduleFilters[0].value" placeholder="search student name"></el-input>
            </el-col>
          </el-row>
          <data-tables :data="classScheduleInt" :action-col="classScheduleIntActionCol" :filters="classScheduleFilters">
            <el-table-column
              v-for="classScheduleInfo in classSchedule"
              :prop="classScheduleInfo.prop"
              :label="classScheduleInfo.label"
              :key="classScheduleInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
        <div v-if="busScheduleInt.length > 0">
          <el-row>
            <el-col :span="6">
              <el-input v-model="busScheduleFilters[0].value" placeholder="search student name"></el-input>
            </el-col>
          </el-row>
          <data-tables :data="busScheduleInt" :action-col="busScheduleIntActionCol" :filters="busScheduleFilters">
            <el-table-column
              v-for="busScheduleInfo in busSchedule"
              :prop="busScheduleInfo.prop"
              :label="busScheduleInfo.label"
              :key="busScheduleInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
        <div v-if="parentWithdrawlFormInt.length > 0">
          <el-row>
            <el-col :span="6">
              <el-input v-model="parentWithdrawlFormFilters[0].value" placeholder="search student name"></el-input>
            </el-col>
          </el-row>
          <data-tables :data="parentWithdrawlFormInt" :action-col="parentWithdrawlFormActionCol" :filters="parentWithdrawlFormFilters">
            <el-table-column
              v-for="parentWithdrawlFormInfo in parentWithdrawlForm"
              :prop="parentWithdrawlFormInfo.prop"
              :label="parentWithdrawlFormInfo.label"
              :key="parentWithdrawlFormInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'

export default {
  name: 'CancelSchedule',
  data() {
    return {
      multipleSelection: [],
      cancelScheduleTypeList: ['Transfer', 'Withdraw', 'Graduate', 'Class Assignment', 'Bus Assignment', 'Parent Withdrawal'],
      cancelScheduleType: '',

      pendingListInt: [],
      pendingList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'StudentFullName',
          label: 'Student Name',
        },
        {
          prop: 'SchoolNameThatGoingToTransfer',
          label: 'Transfer To',
        },
        {
          prop: 'STUSCH_EffectiveDate_convert',
          label: 'Effective Date',
        },
        {
          prop: 'TrasnferCreatedBy',
          label: 'Created By',
        },
      ],
      pendingListActionCol: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.RemoveTransferPendingSchedule(row.PK_STUSCH_ID)
            },
            label: 'Delete',
          },
        ],
      },
      pendingListFilters: [
        {
          prop: 'StudentFullName',
          value: '',
        },
      ],

      pendingListWGInt: [],
      pendingListWG: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'StudentFullName',
          label: 'Student Name',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
        },
        {
          prop: 'CLS_ClassName',
          label: 'Class',
        },
        {
          prop: 'WithdrawnGraduatedDate',
          label: 'Effective Date',
        },
        {
          prop: 'WithdrawnGraduatedCreatedBy',
          label: 'Created By',
        },
      ],
      pendingListWGFilters: [
        {
          prop: ['StudentFullName', 'CLS_ClassName'],
          value: '',
        },
      ],

      classScheduleInt: [],
      classSchedule: [
        {
          prop: 'StudentIndexNo',
          label: 'Student ID',
        },
        {
          prop: 'StudentName',
          label: 'Student Name',
        },
        {
          prop: 'FromClassName',
          label: 'From Class',
        },
        {
          prop: 'ToClassName',
          label: 'To Class',
        },
        {
          prop: 'ClsSheScrEffectiveDate_convert',
          label: 'Effective Date',
        },
      ],
      classScheduleIntActionCol: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.RemoveScheduleStudentClass(row.ClsSheID)
            },
            label: 'Delete',
          },
        ],
      },
      classScheduleFilters: [
        {
          prop: 'StudentName',
          value: '',
        },
      ],

      busScheduleInt: [],
      busSchedule: [
        {
          prop: 'StudentIndexNo',
          label: 'Student ID',
        },
        {
          prop: 'StudentName',
          label: 'Student Name',
        },
        {
          prop: 'FromBusNo',
          label: 'From Bus',
        },
        {
          prop: 'ToBusNo',
          label: 'To Bus',
        },
        {
          prop: 'BusSheEffectiveDate_convert',
          label: 'Effective Date',
        },
      ],
      busScheduleIntActionCol: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.RemoveScheduleBus(row.BusSheID)
            },
            label: 'Delete',
          },
        ],
      },
      busScheduleFilters: [
        {
          prop: 'StudentName',
          value: '',
        },
      ],

      parentWithdrawlFormInt: [],
      parentWithdrawlForm: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'WithdrawStudName',
          label: 'Student Name',
        },
        {
          prop: 'WithdrawDate_Convert',
          label: 'Withdraw Date',
        },
      ],
      parentWithdrawlFormActionCol: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.RemoveParentWithdrawForm(row.WithdrawID)
            },
            label: 'Delete',
          },
        ],
      },
      parentWithdrawlFormFilters: [
        {
          prop: 'WithdrawStudName',
          value: '',
        },
      ],
    }
  },
  async created() {},
  async mounted() {},
  methods: {
    changeSelection(val) {
      this.multipleSelection = val
    },
    Load() {
      this.pendingListInt = []
      this.pendingListWGInt = []
      this.classScheduleInt = []
      this.busScheduleInt = []
      this.parentWithdrawlFormInt = []
      this.pendingListFilters[0].value = ''
      this.pendingListWGFilters[0].value = ''
      this.classScheduleFilters[0].value = ''
      this.busScheduleFilters[0].value = ''
      this.parentWithdrawlFormFilters[0].value = ''

      if (this.cancelScheduleType === 'Transfer') {
        this.GetTransferPendingList()
      } else if (this.cancelScheduleType === 'Withdraw') {
        this.GetWithdrawGraduatePendingList('Withdrawn')
      } else if (this.cancelScheduleType === 'Graduate') {
        this.GetWithdrawGraduatePendingList('Graduated')
      } else if (this.cancelScheduleType === 'Class Assignment') {
        this.getScheduleStudentClass()
      } else if (this.cancelScheduleType === 'Bus Assignment') {
        this.getScheduleBus()
      } else if (this.cancelScheduleType === 'Parent Withdrawal') {
        this.getParentWithdrawForm()
      }
    },
    async GetTransferPendingList() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.getTransferPendingScheduleList()
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Finding Data',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          } else {
            this.pendingListInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async RemoveTransferPendingSchedule(studentSchoolID) {
      try {
        const response = await DataSource.shared.updateTransferPendingScheduleList(studentSchoolID, 'Void')
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Delete Schedule',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.Load()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async GetWithdrawGraduatePendingList(changeType) {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.getWithdrawGraduatePendingScheduleList(changeType)
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Finding Data',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          } else {
            this.pendingListWGInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async RemoveWithdrawGraduatePendingSchedule() {
      try {
        if (this.multipleSelection.length < 1) {
          this.$notify.error({
            title: 'Require',
            message: 'Please select student',
          })
        } else {
          let studentGraduationDatesID = []
          this.multipleSelection.forEach(item => {
            studentGraduationDatesID.push(item.PK_GRD_ID)
          })

          const response = await DataSource.shared.updateWithdrawGraduatePendingScheduleList(JSON.stringify(studentGraduationDatesID), 'Void')
          if (response) {
            if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error on Delete Schedule',
              })
            } else if (response.code === '88') {
              window.location.replace('/')
            } else {
              this.Load()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getScheduleStudentClass() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.getScheduleStudentClass()
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Finding Data',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          } else {
            this.classScheduleInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async RemoveScheduleStudentClass(ClsSheID) {
      try {
        const response = await DataSource.shared.updateScheduleStudentClass(ClsSheID, 'Delete')
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Delete Schedule',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.Load()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getScheduleBus() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.getScheduleBusNo()
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Finding Data',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          } else {
            this.busScheduleInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async RemoveScheduleBus(BusSheID) {
      try {
        const response = await DataSource.shared.updateScheduleusNo(BusSheID, 'Delete')
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Delete Schedule',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.Load()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getParentWithdrawForm() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.getWithdrawDetailBySchoolID('Active')
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Finding Data',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          } else {
            this.parentWithdrawlFormInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async RemoveParentWithdrawForm(withdrawID) {
      try {
        const response = await DataSource.shared.updateWithdrawDetailByID(withdrawID)
        if (response) {
          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error on Delete Schedule',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.Load()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
  },
}
</script>

<style scoped></style>
